<script setup lang="ts">
withDefaults(
  defineProps<{
    /** Section header, e.g. an alphabetical category or "PROCHE DE VOUS" */
    label?: string;
  }>(),
  {
    label: undefined,
  },
);
</script>

<template>
  <div class="list-group">
    <div v-if="label" class="list-group__header">{{ label }}</div>
    <div class="list-group__items">
      <slot />
    </div>
  </div>
</template>

<style lang="scss">
.list-group {
  background-color: $color-white;
  display: flex;
  flex-direction: column;

  &__header {
    color: $color-neutral-higher;
    font: $text-bold-smaller;
    letter-spacing: $text-bold-smaller-spacing;
    padding: $spacing-1 $spacing-5;
    text-transform: uppercase;
  }

  &__items {
    display: flex;
    flex-direction: column;
  }
}
</style>
